import { useEffect, useState } from 'react';
import { getFriendlyCaptchaSiteKey } from '../veevaIdApi';
import ResponseStatus from '../constants/ResponseStatus';
import ErrorPageErrorTypes from '../constants/ErrorPageErrorTypes';

const useFriendlyCaptchaSiteKey = () => {
    const [siteKey, setSiteKey] = useState(null);
    const [error, setError] = useState();

    useEffect(() => {
        getFriendlyCaptchaSiteKey().then((response) => {
            switch (response.responseStatus) {
                case ResponseStatus.SUCCESS: {
                    setSiteKey(response.data);
                    break;
                }
                case ResponseStatus.FAILURE: {
                    const captchaError = {
                        ...response.errors[0],
                        type: ErrorPageErrorTypes.FAILED_TO_LOAD,
                    };
                    setError(captchaError);
                    break;
                }
                case ResponseStatus.UI_NETWORK_ERROR: {
                    setError({ type: ErrorPageErrorTypes.FAILED_TO_LOAD });
                    break;
                }
                default:
            }
        });
    }, []);

    return [siteKey, error];
};

export default useFriendlyCaptchaSiteKey;
